import $http from "@/plugins/axios";

const BaseRestService = (basePath)=> {
    return {
        create(item) {
            return $http.post(basePath, item);
        },
        findAll() {
            return $http.get(basePath)
        },
        findOne(id) {
            return $http.get(`${basePath}/${id}`)
        },
        update(id, item) {
            return $http.post(`${basePath}/${id}`, item)
        },
        remove(id) {
            return $http.delete(`${basePath}/${id}`)
        }
    }
}
export default BaseRestService
